'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const Description_Description = require('../Description/Description.cjs.js');
const ErrorMessage_ErrorMessage = require('../ErrorMessage/ErrorMessage.cjs.js');
const Label_Label = require('../Label/Label.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const radioGroup = "_radio-group_k56ft_1";
const styles = {
	radioGroup: radioGroup
};

const RadioGroup = (_a) => {
  var { children, className, isRequired, label, description, errorMessage } = _a, props = tslib_es6.__rest(_a, ["children", "className", "isRequired", "label", "description", "errorMessage"]);
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    React__default.default.createElement(
      reactAriaComponents.RadioGroup,
      Object.assign({ className: clsx.clsx(className, styles.radioGroup), "data-zds": true }, props),
      label && React__default.default.createElement(Label_Label.Label, { isRequired }, label),
      children,
      description && React__default.default.createElement(Description_Description.Description, null, description),
      React__default.default.createElement(ErrorMessage_ErrorMessage.ErrorMessage, null, errorMessage)
    )
  );
};

exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.cjs.js.map
